module.exports = __webpack_public_path__ + "img/shadow-sm-landscape-150.938bf2c.png";